import React, { useState } from 'react';
import { FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import { GoalDetailHeader } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalDetail/GoalDetailHeader';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import { GoalDetailItem } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalDetail/GoalDetailItem';
import { GoalDetailOverride } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalDetail/MetaOverride';
import OnboardingAddItemButton
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/ExpensesDetail/OnboardingAddItemButton';
import fr from 'facet-rest';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import { v4 as uuid } from 'uuid';

const GoalDetailLayout = () => {
  const {
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();
  const [renderUUID, setRenderUUID] = useState(uuid());
  const { onboardingStepResource } = useSurveyContext();
  const { displayErrorMessage } = useSnackbarContext();

  const handleAdd = async () => {
    try {
      onboardingStepResource.attr('goals').create({ addToCollection: true });
      setRenderUUID(uuid());
    } catch (e) {
      displayErrorMessage(e, e.errors || 'failed to add a new goal');
    }
  };

  const AddNewGoalButton = onboardingStepResource.withRelationship(fr.relationships.addOutcome.name,
    (rel) => <OnboardingAddItemButton relationship={rel} onAdd={() => handleAdd()} />,
    () => null);

  return (
    <FDStack direction="column" spacing={2} alignItems="center" width={'100%'}>
      <GoalDetailHeader />
      <MetaCollectionRenderer
        key={renderUUID}
        collection={onboardingStepResource.attr('goals')}
        layout={GoalDetailItem}
        metaOverrideSet={GoalDetailOverride}
      />
      {AddNewGoalButton}
      <SurveyStepFooter onSubmit={onSubmitMetaForm} />
    </FDStack>
  );
};

GoalDetailLayout.defaultProps = {};

GoalDetailLayout.propTypes = {};

export { GoalDetailLayout };
